import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
	width: 45rem;
	height: auto;
	border-radius: var(--small-border-radius);
	font-size: var(--paragraph3-font-size);
	background: var(--modal-bg-3);
	box-shadow: var(--container-box-shadow);
`;

export const SeeMoreButtonCss = css`
	width: 100%;
	gap: unset !important;

	body[dir='rtl'] & {
		.icon {
			transform: rotate(180deg);
		}
	}
`;

export const CreditHeader = styled.div`
	padding: var(--padding-3);
	display: flex;
	justify-content: center;
	border-bottom: 1px solid var(--border-color);
`;

export const InfoContainer = styled.div`
	display: flex;
	justify-content: space-between;
	border: 1px solid var(--border-color);
	height: var(--topbarCreditHeight);
	width: 100%;

	> div {
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--border-color);
		height: var(--topbarCreditHeight);
		border-radius: var(--small-border-radius) 0 0 var(--small-border-radius);
	}

	> .typography {
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const CODWalletButtonCss = css`
	width: auto;
	padding: 0 !important;
	border: 0 !important;
`;

export const Block = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.4rem;
	padding: var(--padding-3);
	border-bottom: 1px solid var(--border-color);
`;

export const InlineTypography = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	align-items: center;
`;

export const Loading = styled.div`
	width: 3rem;
	margin: auto;
`;

export const FlexContainer = styled.div`
	display: flex;
`;

export const InfoLineMain = styled.div`
	display: grid;
	grid-template-columns: 5rem 1fr;
	gap: 1rem;
	align-items: center;
`;

export const InlineButtons = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 1rem;
	align-items: center;
	justify-items: center;
	width: 100%;
`;
